module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "library-select"
  }, [_c('div', {
    staticClass: "rows"
  }, _vm._l((_vm.rows), function(item) {
    return _c('div', {
      key: item.id,
      class: {
        active: _vm.selectedItemId === item.id
      },
      attrs: {
        "data-id": item.id
      },
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_c('span', {
      style: ({
        'background-color': item.color
      })
    }), _vm._v("\n        " + _vm._s(item.name) + "\n        "), _c('div', {
      staticClass: "buttons"
    }, [_c('a', {
      staticClass: "duplicate",
      attrs: {
        "title": "duplicate"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.duplicateRow(item)
        }
      }
    }, [_c('Copy', {
      staticClass: "button"
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "destroy",
      attrs: {
        "title": "delete"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.destroyItem(item)
        }
      }
    }, [_c('Delete', {
      staticClass: "button"
    })], 1)])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bbb2c29!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LibrarySelect.vue
// module id = 753
// module chunks = 2